import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ToggleButton from 'shared/toggleButton';
import './styles/devModeToggler.scss';

class DevModeToggler extends Component {
  onToggle = (e) => {
    this.props.setSettings({ isDevModeOn: e.target.checked });
  };

  render() {
    return (
      <div className="rf-dev-mode">
        <span className="rf-dev-mode__label">Dev Mode:</span>
        <ToggleButton
          defaultChecked={this.props.isDevModeOn}
          onChange={this.onToggle}
        />
      </div>
    );
  }
}

DevModeToggler.propTypes = {
  setSettings: PropTypes.func.isRequired,
};

export default DevModeToggler;
